import { frenchDate, frenchDateOnly } from "../../../variables/functions";
import entete from '../../../assets/img/entete_pool.png'
import { Image } from "antd";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import '../../../assets/styles/attestationDeclaration.css';
import { DocumentFooter } from "../../../components/docs/DocumentFooter";
import Barre from "../../../components/docs/BarreTop";
import { getCompagnieLogo } from "../../../hooks/useFilesHooks";


const AttestationDeclarationSinistre = React.forwardRef((props, ref) => {
    const [logoPreviewUrl, setLogoPreviewUrl] = useState(null);
    useEffect(() => {
        if (props?.sinistre?.contrat?.organisme?.typeOrganisme !== "POOL") {
            getCompagnieLogo(props?.sinistre?.contrat?.organisme?.code)
                .then(async (response) => {
                    const imageBytes = await response.arrayBuffer();
                    var blob = new Blob([imageBytes], { type: "image/png" });
                    var imageUrl = URL.createObjectURL(blob);
                    setLogoPreviewUrl(imageUrl);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, [props?.sinistre?.contrat?.organisme?.typeOrganisme, props?.sinistre?.contrat?.organisme?.code]);

    return (
        <div className="attestation-container" ref={ref}>
            <div
                className="card"
                style={{ position: "relative", minHeight: "100vh" }}
            >

                <div style={{ flexShrink: 0 }}>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "0px 0px",
                        }}
                    >
                        {props?.sinistre?.contrat?.organisme?.typeOrganisme !== "POOL" && (
                            <Image
                                src={logoPreviewUrl}
                                style={{
                                    width: "100%",
                                    height: "105px",
                                }}
                            />
                        )}

                        <Image
                            src={entete}
                            style={{
                                width: "100%",
                                height: "105px",
                            }}
                        />
                    </div>
                    <Barre />
                </div>
                <div className="attestation-content-wrapper">
                    <table className="attestation-table" border={1}>
                        <tr>
                            <td className="attestation-section-text">
                                <h5 className="attestation-title">ATTESTATION DE DÉCLARATION DE SINISTRE</h5>
                            </td>
                        </tr>
                    </table>
                    <div className="attestation-section-text">
                        <p><b>{props?.sinistre?.contrat?.organisme?.typeOrganisme !== "POOL" ? `La compagnie ${props?.sinistre?.contrat?.organisme?.raisonSociale}` : `Le ${props?.sinistre?.contrat?.organisme?.raisonSociale}`} atteste que le véhicule :</b></p>
                    </div>
                    <div
                        className="attestation-indent"
                    >
                        <table className="attestation-table">
                            <tr>
                                <td>N° Immatriculation:</td>
                                <td className="attestation-section-text"><b>{props?.sinistre?.engin?.immatriculation}</b></td>
                            </tr>
                            <tr>
                                <td>N° Chassis:</td>
                                <td>{props?.sinistre?.engin?.numeroChassis}</td>
                            </tr>
                            <tr>
                                <td>Marque:</td>
                                <td>{props?.sinistre?.engin?.marque}</td>
                            </tr>
                            <tr>
                                <td>Catégorie : </td>
                                <td>{props?.sinistre?.engin?.categorie?.nom.toUpperCase()} </td>
                            </tr>
                            <tr>
                                <td>Appartenant à:</td>
                                <td>
                                    {props?.sinistre?.contrat?.souscripteur?.prenom
                                        ? `${props?.sinistre?.contrat?.souscripteur?.nom} ${props?.sinistre?.contrat?.souscripteur?.prenom} `
                                        : `${props?.sinistre?.contrat?.souscripteur?.nom}`}

                                </td>
                            </tr>
                        </table>

                    </div>

                    <div className="attestation-section-text">
                        <p><b>est assuré sous la police d&apos;assurance :</b></p>
                    </div>
                    <div
                        className="attestation-indent"
                    >
                        <table className="attestation-table">
                            <tbody>
                                <tr>
                                    <td className="attestation-section-text"> <b>N° Police:</b>  </td>
                                    <td className="attestation-section-text">
                                        <b>{props?.sinistre?.contrat?.numeroPoliceM
                                            ? props?.sinistre?.contrat?.numeroPoliceM
                                            : props?.sinistre?.contrat?.numeroPoliceP}
                                        </b>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Effet :</td>
                                    <td>
                                        {frenchDate(props?.sinistre?.contrat?.dateEffet)}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Echéance : </td>
                                    <td>
                                        {frenchDate(props?.sinistre?.contrat?.dateEcheance)}
                                    </td>
                                </tr>
                            </tbody>

                        </table>
                    </div>

                    <div className="attestation-paragraph">
                        <p className="attestation-section-text">
                            Le sinistre survenu le{" "}
                            <b>{frenchDate(props?.sinistre?.dateSinistre)} </b>,
                            déclaré le{" "}
                            <b>{frenchDateOnly(props?.sinistre?.dateDeclaration ?? props?.sinistre?.createdAt)} aux environs de {props?.sinistre?.dateDeclaration?.split("T")[1]?.split(".")[0]?.split(":")[0]}:{props?.sinistre?.dateDeclaration?.split("T")[1]?.split(".")[0]?.split(":")[1]} </b> est
                            enrégistré sous le numéro{" "}
                            <b>{props?.sinistre?.numeroSinistreM || props?.sinistre?.numSinistre} </b>
                        </p>
                        <p>
                            En foi de quoi, la présente attestation est délivrée pour
                            servir et valoir ce que de droit, en particulier au
                            retrait des pièces et / ou du véhicule auprès des agents
                            ayant effectué le constat.
                        </p>
                        <p className="attestation-section-text">
                            <b>
                                Cette attestation ne présente qu&apos;un caractère
                                administratif et ne constitue en rien une quelconque
                                reconnaissance de responsabilité totale comme
                                partielle de {props?.sinistre?.contrat?.organisme?.raisonSociale}.
                            </b>
                        </p>
                        <p>
                            <b>
                                Afin de nous permettre d'instruire le dossier et de contacter éventuellement les victimes, nous prions de bien vouloir
                                nous transmettre le procès-verbal / rapport de constat conformément aux dispositions de l'article 230 du Code CIMA.
                            </b>
                        </p>
                        <p className="attestation-section-text">
                            <em>
                                <b>
                                    NB: Cette prise de déclaration de sinistre vaut
                                    demande de rapport d&apos;accident ou du PV de
                                    constat.
                                </b>
                            </em>
                        </p>
                        <p className="attestation-paragraph">
                            Entité ayant fait le constat :{" "}
                            {props?.sinistre?.entiteConstat?.nom?.toUpperCase()}
                        </p>
                    </div>
                    <div className="attestation-footer-details" >
                        <div>

                        </div>
                        <div className="attestation-signature-block">
                            <span className="attestation-signature-label">Fait à Lomé le {frenchDate(props?.sinistre?.dateDeclaration)}</span>
                            <span className="attestation-signature-label">Pour la société</span>
                            <div className="attestation-signature-space"></div> {/* Space for signature image or text */}
                            {/* Placeholder for actual signature image if you have one */}
                            {/* <img src={signatureImage} alt="Signature" style={{ width: '100px', height: 'auto' }} /> */}
                        </div>
                    </div>
                </div>
                {/* <Image src={entfoot} /> */}
                <div style={{ flexShrink: 0, marginTop: "0" }}>
                    <DocumentFooter />
                </div>
            </div>
        </div >
    );
});

AttestationDeclarationSinistre.propTypes = {
    sinistre: PropTypes.object,
};

export default AttestationDeclarationSinistre;
